import { createSelector } from 'reselect';
import defaultSettings, {
  COMPACT_SHOW_VIDEO_LIST_VALUES,
  COMPACT_PLAY_TYPE_VALUES,
  MAIN_ACTION_STYLE_TYPES,
  mainItemTypeValues,
  layoutStyleValues,
} from 'default-settings';


export function getAllSettings(state) {
  return state.appSettings;
}

export function getRequestedWidgetSize(state) {
  return _.get(state, 'appSettings.requestedWidgetSize');
}

export function getNumberOfRows(state) {
  return _.get(state, 'appSettings.numbers.numberOfRows', defaultSettings.numbers.numberOfRows);
}

export function getVideosInRowCount(state) {
  return _.get(state, 'appSettings.numbers.videosInRow', defaultSettings.numbers.videosInRow);
}

export function getVideoInfoPosition(state) {
  return _.get(state, 'appSettings.numbers.videoInfoPosition', defaultSettings.numbers.videoInfoPosition);
}

export function getInfoActionVisibility(state) {
  return _.get(state, 'appSettings.numbers.showInfoAction', defaultSettings.numbers.showInfoAction);
}

export function getLayoutStyle(state) {
  return _.get(state, 'appSettings.numbers.layoutStyle', defaultSettings.numbers.layoutStyle);
}

export function getSiteUrl(state) {
  return _.get(state, 'appSettings.siteUrl');
}

export function getCompId(state) {
  return _.get(state, 'appSettings.compId');
}

export function getInstance(state) {
  return _.get(state, 'appSettings.instance');
}

export function getCompactPlayType(state) {
  return _.get(state, 'appSettings.numbers.compactPlayType', defaultSettings.numbers.compactPlayType);
}

export function getCompactMainActionStyleType(state) {
  return _.get(state, 'appSettings.numbers.mainActionStyleType', defaultSettings.numbers.mainActionStyleType);
}

export function getChannelLayout(state) {
  return _.get(state, 'appSettings.numbers.channelLayout', defaultSettings.numbers.channelLayout);
}

export function canShowSearch(state) {
  return _.get(state, 'appSettings.booleans.showSearch', defaultSettings.booleans.showSearch);
}

export function canShowMainItemTitle(state) {
  return _.get(state, 'appSettings.booleans.showTitleForMainItem', defaultSettings.booleans.showTitleForMainItem);
}

export function canShowActionBar(state) {
  return _.get(state, 'appSettings.booleans.showActionBar', defaultSettings.booleans.showActionBar);
}

export function canShowChannelInfo(state) {
  return _.get(state, 'appSettings.booleans.showChannelInfo', defaultSettings.booleans.showChannelInfo);
}

export function canShowChannelShare(state) {
  return _.get(state, 'appSettings.booleans.showChannelShare', defaultSettings.booleans.showChannelShare);
}

export function canShowSignIn(state) {
  return _.get(state, 'appSettings.booleans.showSignIn', defaultSettings.booleans.showSignIn);
}

export function canShowVideoList(state) {
  const value = _.get(state, 'appSettings.numbers.compactShowVideoList', defaultSettings.numbers.compactShowVideoList);
  return value !== COMPACT_SHOW_VIDEO_LIST_VALUES.NEVER;
}

export function canShowMainItemPublisher(state) {
  return _.get(state, 'appSettings.booleans.showPublisherForMainItem', defaultSettings.booleans.showPublisherForMainItem);
}

export function isPreviewHover(state) {
  return _.get(state, 'appSettings.booleans.previewHover', false);
}

export function isVideoListPreviewHover(state) {
  return _.get(state, 'appSettings.booleans.videoListPreviewHover', false);
}

export function canShowVideoListItemPublisher(state) {
  return _.get(state, 'appSettings.booleans.showVideoPublisherInList', defaultSettings.booleans.showVideoPublisherInList);
}

export function canShowVideoListItemTitle(state) {
  return _.get(state, 'appSettings.booleans.showVideoTitleInList', defaultSettings.booleans.showVideoTitleInList);
}

export const canShowChannelTags = createSelector(
  [
    canShowSearch,
    state => _.get(state, 'appSettings.booleans.showChannelTags', defaultSettings.booleans.showChannelTags),
  ],
  (canShowSearch, canShowTags) => canShowSearch && canShowTags,
);

export function getMainItemType(state) {
  return _.get(state, 'appSettings.numbers.mainItemType', defaultSettings.numbers.mainItemType);
}

export const isMainItemFeaturedVideo = createSelector(
  [
    getMainItemType,
  ],
  mainItemType => mainItemType === mainItemTypeValues.FEATURED_VIDEO,
);

export const areElementsRounded = createSelector(
  [
    getLayoutStyle,
  ],
  layoutStyle => layoutStyle === layoutStyleValues.ROUND,
);

export const isCompactPlayInFrame = createSelector(
  [
    getCompactPlayType,
  ],
  playType => playType === COMPACT_PLAY_TYPE_VALUES.IN_FRAME,
);

export const isCompactMainActionsOnlyIcons = createSelector(
  [
    getCompactMainActionStyleType,
  ],
  styleType => styleType === MAIN_ACTION_STYLE_TYPES.ICON,
);




// WEBPACK FOOTER //
// ./src/shared/selectors/app-settings.js